// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/dist/cjs.js??ref--0-1!../../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../../node_modules/postcss-loader/src/index.js??ref--0-2!../../../node_modules/sass-loader/dist/cjs.js??ref--0-3!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Buttons.vue?vue&type=style&index=0&lang=scss&");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("6e6b35a5", content, true, {});